import { usePrefectures } from '@/modules/Prefectures'

export const useCity = (cityCode?: string) => {
  const { data: prefectures } = usePrefectures(!!cityCode)

  const city = prefectures
    ?.find((pref) => pref.cities.some((city) => city.code === Number(cityCode)))
    ?.cities.find((city) => city.code === Number(cityCode))

  return city
}
